// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"1357c4f9","638":"1357c4f9"}[chunkId] + ".chunk.css";
};